import type { TAutomationModeOption } from '~/modules/opportunities/automated-email/settings/types';
import { EAutomationMode } from '~/modules/opportunities/automated-email/types';

import { getAutomationModeOptions } from '~/modules/opportunities/automated-email/settings/config';

export const coerceSelectableAutomationMode = (
  value: EAutomationMode,
  isLettings: boolean = false
): EAutomationMode => {
  const option: TAutomationModeOption | undefined = getAutomationModeOptions(isLettings).find(
    (o: TAutomationModeOption): boolean => o.value === value
  );

  if (option?.disabled) {
    return EAutomationMode.SEMI_AUTOMATIC;
  }

  return value;
};
